/*
|--------------------------------------------------------------------------
| Utilities: Google Map
|--------------------------------------------------------------------------
*/

/**
 * Create a google map
 * @namespace
 */
__gh__webApp.utilities.googleMap = {

	"drawMap": function(options){
		var dom 				= (options.dom) 		? options.dom 		: null,
			locations			= (options.locations) 	? options.locations : null,
			fetchHandlebarsView = __gh__webApp.utilities.fetch.handlebarsView.get;

		//Create map
		var map = new google.maps.Map(document.querySelector(dom),{
				"mapTypeId"		: google.maps.MapTypeId.ROADMAP,
				"scrollwheel"	: false
			}),
			infoWindow 	= new google.maps.InfoWindow(),
			bounds 		= new google.maps.LatLngBounds();

		//Add map markers
		for (var i = 0; i < locations.length; i++) {
			 var marker = new google.maps.Marker({
					 "position"	: {"lat": locations[i].latitude, "lng": locations[i].longitude},
					 "map"		: map
				 });

			bounds.extend(marker.position);

			google.maps.event.addListener(marker, 'click', (function (marker, i) {
				var infoWindowView 	= "buckets/article/relatedContent/map/partials/_locationInfo",
					content 		= fetchHandlebarsView({"view":infoWindowView,"data":locations[i]});
	            return function () {
	                infoWindow.setContent(content);
	                infoWindow.open(map, marker);
	            }
	        })(marker, i));
		}

		// Centers map view around to show the markers that were added
		map.fitBounds(bounds);

		var listener = google.maps.event.addListener(map, "idle", function () {
	        google.maps.event.removeListener(listener);
	    });
    },


    "loadAllMaps": function(){
	    var googleMap 			= __gh__webApp.utilities.googleMap;
			loadLibrary 		= googleMap.loadLibrary();

		if(loadLibrary){return;}

	    $("[data-gh-google-maps-loaded=false]").each(function(){
			var $container = $(this);

			//Only load each map once.
			if(!$container.data("gh-google-maps-loaded")){
				$container.attr("data-gh-google-maps-loaded",true);

				var options	= {
					"locations"	: $container.data("gh-google-maps-locations"),
					"dom"		: $container.data("gh-google-maps-dom")
				};

				googleMap.drawMap(options);
			}
	  	});
    },


    "loadLibrary": function(){
	    return __gh__webApp.common.loadScript({
		    "src": "http://maps.googleapis.com/maps/api/js?key=AIzaSyA9V0BVjWx9UDs42pKydVMFGsu4K4gpz-g",
		    "onload": __gh__webApp.utilities.googleMap.loadAllMaps
	    })
    }

};